<template>
  <div>
    <a-spin :spinning="spinning">
      <a-form-model :rules="rules" ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <!-- <a-row>
          <a-col span="10">
          <a-form-model-item :label="$t('message.txtManagement.userPlace')" :label-col="{span:13}" :wrapper-col="{span:11}">
            #{user}
          </a-form-model-item>
        </a-col>
        <a-col span="14">
          <a-form-model-item :label="$t('message.txtManagement.couponPlace')" :label-col="{span:12}" :wrapper-col="{span:12}">
            #{coupon}
          </a-form-model-item>
        </a-col>
        </a-row> -->
        <a-form-model-item :label="$t('message.commonUsage.template')" prop="template_id">
          <a-select :size="$globalSize" v-model="form.template_id" :placeholder="$t('message.commonUsage.template')" :options="templateOpt"></a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('message.txtManagement.tableTitle2')" prop="content_name">
          <a-input :size="$globalSize" v-model="form.content_name" :placeholder="$t('message.txtManagement.tableTitle2')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('message.txtManagement.subject')" prop="subject">
          <a-input :size="$globalSize" v-model="form.subject" :placeholder="$t('message.txtManagement.subject')" />
        </a-form-model-item>
        <a-form-model-item v-for="item in curTemplate.replaceable_elements" :label="item.replaceAll('_',' ')" :prop="item" :key="item">
          <div v-if="item === 'content'" style="position: relative">
            <a-textarea :size="$globalSize" v-model="form.contentValue.content" :rows="6" style="resize: none" />
          </div>
          <a-input :size="$globalSize" v-else v-model="form.contentValue[item]" :placeholder="item.replaceAll('_',' ')" />

        </a-form-model-item>
      </a-form-model>
    </a-spin>
    <text-library-select-modal ref="selectTextModalRef" @changeCopyWrite="syncText"></text-library-select-modal>
  </div>
</template>

<script>
import utils from "@/utils";
import textLibrarySelectModal from "@/views/material/components/textLibrarySelectModal";
import contentListService from "@/interface/pages/TxtManagement/contentListService";

export default {
  name: "EmailPushTemp",
  components: {
    textLibrarySelectModal
  },
  inject: {
    parent: {
      from: 'parent'
    },
    changePreviewItem: {
      from: 'changePreviewItem',
      default: () => { }
    }
  },
  props: {
    channel: String
  },
  data() {
    return {
      spinning: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 10 : 10
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 14 : 14
      },
      form: {
        content_name: '',
        subject:'',
        template_id: '',
        contentValue: {},
        //这里的content是最后编辑完的值
        content: '',
      },
      templateOpt: [],
      channelKey: this.channel,
      rules: {
        content_name: [{ required: true, message: this.$t('message.txtManagement.tableTitle2'), trigger: 'blur' }],
        subject: [{ required: true, message: this.$t('message.txtManagement.subject'), trigger: 'blur' }],
      },
      curTemplate: {
        replaceable_elements: []
      },
      finallyContent: ''
    }
  },
  watch: {
    channel(v) {
      this.channelKey = v
    },
    form: {
      handler(v) {
        if (v) {
          const cur = this.templateOpt.find(i => i.value === v.template_id) || {}
          this.finallyContent = cur.template_content;
          cur.replaceable_elements.forEach(item => {
            const regex = new RegExp(`\\$\\{\\s*${item}\\s*\\}`, 'g');
            this.finallyContent = this.finallyContent.replace(regex, v.contentValue[item] || '');
          });
          this.changePreviewItem && this.changePreviewItem({ type: this.channelKey, detail: this.finallyContent })
        }
      },
      deep: true,
    },
    'form.template_id': {
      handler(v) {
        this.curTemplate = this.templateOpt.find(i => i.value === v) || {}
      },
      deep: true,
    }
  },
  methods: {
    async getTemplateOpts() {
      this.spinning = true
      const { data: res } = await contentListService.getEmailTemplateOptions(this, { params: { } })
      if (res.code === '200') {
        this.templateOpt = res.data.map(v => {
          return {
            label: v.template_name,
            value: v.template_id,
            ...v
          }
        })
        if (this.parent.currentItem) {
          this.curTemplate = res.data.find(v=>v.template_id === this.parent.currentItem.template_id) || {}
          this.form = { ...this.parent.currentItem,contentValue:this.parent.currentItem.content_value}
        }
      }
      this.spinning = false
    },
    syncText(v) {
      this.form.content = v
    },
    formValidate() {
      let data
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate( valid => {
          if (!valid) {
            reject(new Error('form  error '))
            return
          }
          data = { ...this.form, content: this.finallyContent }
          resolve({ ...data })
        })
      })
    }
  },
  mounted() {
    this.getTemplateOpts()
    utils.languageChange(this, { labelCol: 8, wrapperCol: 16 }, { labelCol: 6, wrapperCol: 16 })

  },
  beforeDestroy() {
    this.$refs.ruleForm.resetFields()
  }
}
</script>

<style scoped></style>